const formatDecimal = (value: number): string => {
  // const fixedTwo = value.toFixed(2)
  const truncatedNumber = Math.floor(value * 100) / 100
  // console.error(truncatedNumber,truncatedNumber.toFixed(2))
  return truncatedNumber.toFixed(2)
  // const fixedOne = value.toFixed(1)
  // Check if the two decimal version is necessary
  // if (parseFloat(fixedTwo) === parseFloat(fixedOne)) {
  //   return fixedOne
  // } else {
  //   return fixedTwo
  // }
}

const toFixedNoRounding = (val: number, decimals: number) => {
  const multiplier = Math.pow(10, decimals)
  return Math.floor(val * multiplier) / multiplier
}

/**
 *
 * @param unit 单位
 * @returns
 */
let initFormatConfig: { unit: { K: string; M: string; B: string }; country: string } = {
  unit: { K: 'K', M: 'M', B: 'B' },
  country: 'zh-CN'
}
const formatInit = (
  formatConfig: typeof initFormatConfig = { unit: { K: 'K', M: 'M', B: 'B' }, country: 'zh-CN' }
) => {
  initFormatConfig = formatConfig
}
const getFormatConfig = () => initFormatConfig
/**
 * 将数字格式化为KMB表示，并最多保留两位小数
 * @param num
 * @returns
 */
const formatNumberStort = (val: number): string => {
  const num = Math.abs(val)
  const prefix = val < 0 ? '-' : ''
  if (num >= 1e9) {
    return prefix + formatDecimal(num / 1e9) + getFormatConfig().unit.B
  } else if (num >= 1e6) {
    return prefix + formatDecimal(num / 1e6) + getFormatConfig().unit.M
  } else if (num >= 1e3) {
    return prefix + formatDecimal(num / 1e3) + getFormatConfig().unit.K
  } else {
    return prefix + formatDecimal(num)
  }
}
/**
 * @description id-ID 专用; 超过1e6才缩写, 默认不保留小数部分
 * @param val
 * @param digits 保留小数位数(default: 0)
 * @param normal 是否在千分位的时候缩写(default: false)
 */
const formatNumberInt = (val: number, digits: number = 2, normal: boolean = false): string => {
  const num = Math.abs(val)
  const prefix = val < 0 ? '-' : ''
  if (num >= 1e9) {
    return prefix + numberFormat(num / 1e9, digits, true) + getFormatConfig().unit.B
  } else if (num >= 1e6) {
    return prefix + numberFormat(num / 1e6, digits, true) + getFormatConfig().unit.M
  }
  if (normal && num >= 1e3) {
    return prefix + numberFormat(num / 1e3, digits, true) + getFormatConfig().unit.K
  } else {
    return prefix + numberFormat(num, 0, false)
  }
}

const numberFormat = (val: number, digits: number = 2, digitsNoZero = false) => {
  if (!digits) {
    if (val) {
      val = Math.floor(val * 100) / 100
    }
  }

  if (!digitsNoZero) {
    const result = new Intl.NumberFormat(getFormatConfig().country, {
      style: 'decimal',
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(val ?? 0)
    if (result.endsWith('.00') || result.endsWith(',00')) {
      return result.slice(0, -3)
    }

    return result
  }
  //先按照正常小数处理，在转换成相应的千分位和小数点符号
  let formatted = `${toFixedNoRounding(val, 2)}` //val.toFixed(2)

  if (formatted.includes('.')) {
    formatted = formatted.replace(/0+$/, '') // 去掉末尾的0
    if (formatted.endsWith('.')) {
      formatted = formatted.slice(0, -1) // 如果去掉0后只剩下小数点，去掉小数点
    }
  }
  const isID = initFormatConfig.country === 'id-ID'
  //根据地区规则重新格式化千分位和小数点符号
  if (isID) {
    // 印尼地区：小数点用逗号，千分位用点
    const parts = formatted.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') // 千分位加点
    formatted = parts.join(',')
  } else {
    // 正常地区：小数点用点，千分位用逗号
    const parts = formatted.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') // 千分位加逗号
    formatted = parts.join('.')
  }

  return formatted
}

/**
 * 格式化 1,000,000.00
 */

const formCurrency = (value: number | string) => {
  if (typeof value === 'string') value = Number(value)
  return new Intl.NumberFormat('zh-CN', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value ?? 0)
}

const formatCurrency1 = (val: number | string) => {
  if (typeof val === 'string') {
    val = Number(val)
  }
  val = val ?? 0
  const num = Math.abs(val)
  const prefix = val < 0 ? '-' : ''
  if (num >= 1e12) {
    return prefix + numberFormat(Math.floor((num * 100) / 1e9) / 100, 2) + getFormatConfig().unit.B
  } else if (num >= 1e9) {
    return prefix + numberFormat(Math.floor((num * 100) / 1e6) / 100, 2) + getFormatConfig().unit.M
  } else if (num >= 1e6) {
    return prefix + numberFormat(Math.floor((num * 100) / 1e3) / 100, 2) + getFormatConfig().unit.K
  } else {
    return prefix + numberFormat(num, 2)
  }
}

const formatCurrency1WithoutDigit = (val: number | string) => {
  if (typeof val === 'string') {
    val = Number(val)
  }
  val = val ?? 0
  const num = Math.abs(val)
  const prefix = val < 0 ? '-' : ''
  if (num >= 1e12) {
    return prefix + numberFormat(Math.floor(num / 1e9), 0) + getFormatConfig().unit.B
  } else if (num >= 1e9) {
    return prefix + numberFormat(Math.floor(num / 1e6), 0) + getFormatConfig().unit.M
  } else if (num >= 1e6) {
    return prefix + numberFormat(Math.floor(num / 1e3), 0) + getFormatConfig().unit.K
  } else {
    return prefix + numberFormat(Math.floor(num), 0)
  }
}
/**
 * @description 只有K, M 没有D 的格式化
 * @param val
 * @param digits default: 2
 * @param digitsNoZero
 * @returns
 */
const formatNumberKM = (val: number, digits: number = 2) => {
  const num = Math.abs(val)
  const prefix = val < 0 ? '-' : ''
  if (num >= 1e6) {
    return prefix + numberFormat(num / 1e6, digits, true) + getFormatConfig().unit.M
  } else if (num >= 1e3) {
    return prefix + numberFormat(num / 1e3, digits, true) + getFormatConfig().unit.K
  } else {
    return prefix + numberFormat(num, 0, false)
  }
}
const formatOnlyK = (val: number | string) => {
  typeof val === 'string' && (val = Number(val))
  const num = Math.abs(val)
  const prefix = val < 0 ? '-' : ''
  if (num >= 1e3) {
    return prefix + numberFormat(Math.floor(num / 1e3), 0) + 'K'
  } else {
    return prefix + numberFormat(Math.floor(num), 0)
  }
}

function getLocaleSeparators(locale: string) {
  // 使用样例数字获取格式化结果
  const formatted = new Intl.NumberFormat(locale).format(1234.56)

  // 提取千位分隔符和小数点
  const thousandSeparator = formatted[1] // 第二个字符是千分位分隔符
  const decimalSeparator = formatted[5] // 第五个字符是小数点分隔符

  return { thousandSeparator, decimalSeparator }
}
/**
 * 输入金额格式化  1,000,000
 * @returns
 */
const amountFormat = (event: any): string => {
  const { thousandSeparator, decimalSeparator } = getLocaleSeparators(getFormatConfig().country)
  const reg = new RegExp(`[^\\d${decimalSeparator === ',' ? '' : '.'}]`, 'g')
  let value = event.toString().replace(reg, '')
  // value = value.replace(/[^\d.]/g, '')
  const parts = value.split(decimalSeparator)
  if (parts.length > 1) {
    const decimalPart = parts[1].slice(0, 2)
    value = parts[0] + decimalSeparator + decimalPart
  }
  // 检查整数部分是否为0，但不等于"0."（即0.99这种情况）
  if (value.startsWith('0') && !value.endsWith(decimalSeparator) && value !== '0') {
    value = value.slice(1)
  }
  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)
  return value
}
/**
 * 把千分位分割的数字字符串还原成数字   1,000,000 => 1000000
 * @param formattedString string
 * @returns
 */
function formatToNumber(formattedString: string): number {
  if (!formattedString || typeof formattedString !== 'string') {
    return 0
  }
  const regex = new RegExp(
    getLocaleSeparators(getFormatConfig().country).thousandSeparator === '.'
      ? '\\.'
      : getLocaleSeparators(getFormatConfig().country).thousandSeparator,
    'g'
  )
  const numberString = formattedString.replace(regex, '')
  const numberValue = parseFloat(numberString)
  if (isNaN(numberValue)) {
    console.error('Parsing error: input cannot be converted to a number.')
    return 0
  }
  return numberValue
}

/**
 * 将数字四舍五入到两位小数
 * @param num 需要四舍五入的数字
 * @returns 四舍五入到两位小数后的结果
 */
const roundToTwoDecimalPlaces = (num: number) => {
  // 通过乘以100然后取整再除以100的方式，实现四舍五入到两位小数
  return Math.round(num * 100) / 100
}

const getRandomInt = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 格式化小数显示
 * @param value 
 * @param decimals 
 * @param roundingMode 
 * @returns 
 */
const applyRounding = (
  value: number,
  decimals: number,
  roundingMode: 'truncate' | 'floor' | 'ceil' | 'round'
) => {
  const factor = Math.pow(10, decimals)

  switch (roundingMode) {
    case 'truncate':
      // 直接截断，不四舍五入
      return Math.trunc(value * factor) / factor

    case 'floor':
      // 向下取整
      return Math.floor(value * factor) / factor

    case 'ceil':
      // 向上取整
      return Math.ceil(value * factor) / factor

    case 'round':
    default:
      // 四舍五入（默认）
      return Math.round(value * factor) / factor
  }
}
/**
 * 将数字转换为百分比格式
 * @param {number} value - 输入值（如 12000）
 * @returns {string} 百分比字符串（如 "12%" 或 "12.5%" 或 "12.55%"）
 */
const formatToPercent = (value: number, divide: number = 100) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '0%'
  }
  
  // 除以 100 得到百分比数值
  const percent = value / divide
  
  // 检查是否为整数
  if (percent % 1 === 0) {
    return `${percent}%`
  }
  
  // 有小数，保留最多两位小数，并去掉末尾的 0
  const formatted = percent.toFixed(2).replace(/\.?0+$/, '')
  return `${formatted}%`
}
export const useNumberUtils = () => ({
  formatInit,
  getFormatConfig,
  formatNumberStort,
  formatNumberInt,
  amountFormat,
  formatToNumber,
  formCurrency,
  formatCurrency1,
  formatCurrency1WithoutDigit,
  numberFormat,
  getRandomInt,
  roundToTwoDecimalPlaces,
  formatOnlyK,
  formatNumberKM,
  applyRounding,
  formatToPercent
})
